import {DataItems} from '@convincely/components/src/components/Item/DataItems.js';
import {derived, writable} from '@convincely/components/src/library.js';

export const steps = new DataItems([], 'name');
export const stepsOffset = writable(0);
export const pageName = writable();
export const stepSubmitted = writable(false);
export const refreshStore = writable({});
export const section = writable('');
export const sections = derived(steps, ($steps) => {
  return $steps.reduce((acc, {section}, index) => {
    if (section === 'none') {
      return acc;
    }

    acc.total++;

    if (!acc.order.includes(section)) {
      acc.order.push(section);
      acc.stats[section] = {};
      acc.stats[section].activeAt = index;
      acc.stats[section].total = 1;
    } else {
      acc.stats[section].total++;
    }

    // Calculate percentage
    acc.order.forEach((section) => {
      acc.stats[section].percentage = (acc.stats[section].total / acc.total) * 100;
    });

    return acc;
  }, {
    order: [],
    total: 0,
    stats: {},
  });
});

export function forceRefresh(obj = {}, store = refreshStore) {
  store.set(obj);
}


